import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { Product } from './catalog.service';

export interface CompanySummary {
  products: number;
  plans_on_sale: number;
  plans_without_price: number;
}

export interface Company {
  id: number;
  slug: string;
  name: string;
  legal_name: string | null;
  document: string | null;
  billing_email: string | null;
  color: string;
  active: boolean;
  summary: CompanySummary;
  products?: Product[];
}

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private readonly http = inject(HttpClient);
  /** Lista do menu lateral; recarregada quando algo muda nos resumos. */
  readonly list = signal<Company[]>([]);

  async refreshList(): Promise<Company[]> {
    const list = await firstValueFrom(this.http.get<Company[]>('/api/admin/companies'));
    this.list.set(list);
    return list;
  }

  get(id: number): Observable<Company> {
    return this.http.get<Company>(`/api/admin/companies/${id}`);
  }

  update(id: number, data: Partial<Company>): Observable<Company> {
    return this.http.patch<Company>(`/api/admin/companies/${id}`, data);
  }

  moveProduct(productId: number, companyId: number): Observable<Product> {
    return this.http.patch<Product>(`/api/admin/products/${productId}`, { company_id: companyId });
  }
}
